import { AuthResponse } from './AuthResponse';

export enum RefreshTokenResult {
    Success = 'Success',
    InvalidCredentials = 'InvalidCredentials',
    OnHold = 'OnHold',
}

export interface RefreshTokenResponse extends AuthResponse {
    result: RefreshTokenResult;
}
